import React from "react"
import {ClientKey} from "../../../config/app-config"
import {themeByClientKey} from "../../../theme/theme"

type Props = {
  clientKey: ClientKey
  clientName?: string
  onContinue: () => void
  onDeAuthorize: () => void
  loginPageTitle: {
    title: string
  }
}
export const LoggedInCTA: React.FC<Props> = ({
  clientKey,
  clientName,
  onContinue,
  onDeAuthorize,
  loginPageTitle,
}) => {
  const { systemSubtitle, titleClassName } = themeByClientKey(clientKey)
  return <div className="form-layout">
    <div className="form">
      <div className="detail">
        <p className={ titleClassName } style={{textAlign: "center"}}>{loginPageTitle.title}</p>
        <p className="header" style={{textAlign: "center"}}>{ systemSubtitle }</p>
      </div>

      <div className="mb-5">
        <button type="button" onClick={onContinue}
          className="button">Continue{clientName && ` (${clientName})`}</button>
        <br/>
        <button type="button" onClick={onDeAuthorize} className="button">Log out</button>
      </div>
    </div>
  </div>
}